module.exports = __webpack_public_path__ + "static/img/banner1X.32617ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner1X.png
// module id = 1665
// module chunks = 5